import { isValueEmpty, isObject } from "../utils.js";
function valueContains(givenValue, expectedValue) {
  if (isValueEmpty(givenValue)) {
    return false;
  }
  if (isObject(givenValue)) {
    return Object.values(givenValue).includes(expectedValue);
  }
  if (Array.isArray(givenValue) || typeof givenValue === "string") {
    return givenValue.indexOf(expectedValue) > -1;
  }
  throw new Error(
    `Contains operator: Unsupported values to compare ${JSON.stringify(
      givenValue
    )}, ${JSON.stringify(expectedValue)}`
  );
}
export {
  valueContains
};
//# sourceMappingURL=contains.js.map
